import { Flex, Typography, TypographyProps } from '@aloft/toolkit-sui';

import { readOnlyFieldTypographyProps } from '../../../components/PropertyGrid/fields/consts.ts';
import { getAdjustmentColor } from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridForm,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';
import { selectCompAdjustments } from '../../../redux/features/selectors/adjustmentSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { useWatch } from 'react-hook-form';

const Separator = () => (
  <Flex width="100%" height="1px" gridColumn="1 / -1" backgroundColor="textPrimary" />
);

export const AdjustmentsGridAdjustedSPSection = ({
  columnIndex,
  fieldTypes,
  control,
}: PropertyGridSectionProps) => {
  const propertyId = useWatch({
    name: `columns.${columnIndex}.propertyId`,
    control,
  });

  const { adjustedSalePrice, grossAdjustmentPct, netAdjustment, netAdjustmentPct } =
    useAppSelector(selectCompAdjustments)[propertyId] ?? {};

  const showLabels = fieldTypes.includes('label');

  const typographyProps: TypographyProps = {
    ...readOnlyFieldTypographyProps,
    __dangerDoNotUseSx: {
      ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
      gridColumn: showLabels ? '2 / -1' : '1 / -1',
    },
  };

  return (
    <>
      <Separator />
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Net Adj. Total</Typography>}
      <Typography
        {...typographyProps}
        color={getAdjustmentColor(netAdjustment?.adjustment)}
        textAlign="right"
      >
        {netAdjustment?.adjustment?.toString(true) ?? '-'}
      </Typography>
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Net Adj. %</Typography>}
      <Typography {...typographyProps} textAlign="right">
        {netAdjustmentPct?.value ?? '-'}
      </Typography>
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Gross Adj. %</Typography>}
      <Typography {...typographyProps} textAlign="right">
        {grossAdjustmentPct?.value ?? '-'}
      </Typography>
      <Separator />
      {showLabels && <Typography {...readOnlyFieldTypographyProps}>Adjusted SP</Typography>}
      <Typography
        {...typographyProps}
        color={getAdjustmentColor(adjustedSalePrice?.adjustment)}
        textAlign="right"
      >
        {adjustedSalePrice?.value ?? '-'}
      </Typography>
    </>
  );
};
